export class Countrys {
    public CountryID: number;
    public CountryName: string;
    public PrefixCode:string;
    public ISOCode: string;
}